import React from 'react';
import './ResearchPage.css';

const ResearchPage: React.FC = () => {
  return (
    <div className="page-container research-page">
      <h1>Neuroscience Research</h1>

      <div className="research-content">
        <div className="research-section">
          <h2>Transcranial Direct Current Stimulation and Motor Learning</h2>

          <p>
            <strong>Background:</strong> Transcranial direct current stimulation (tDCS) can enhance
            cognitive function in healthy individuals, with promising applications as a therapeutic
            intervention. Despite this potential, variability in the efficacy of tDCS has been a
            considerable concern.
          </p>

          <p>
            <strong>Objective/Hypothesis:</strong> Given that tDCS is always applied at a set
            intensity, we examined whether individual differences in sensitivity to brain
            stimulation might be one variable that modulates the efficacy of tDCS in a motor
            learning task.
          </p>

          <p>
            <strong>Methods:</strong> In the first part of the experiment, single-pulse transcranial
            magnetic stimulation (TMS) over primary motor cortex (M1) was used to determine each
            participant's resting motor threshold (rMT). This measure was used as a proxy of
            individual sensitivity to brain stimulation. In an experimental group of 28
            participants, 2 mA tDCS was then applied during a motor learning task with the anodal
            electrode positioned over left M1. Another 14 participants received sham stimulation.
          </p>

          <p>
            <strong>Results:</strong> M1-Anodal tDCS facilitated learning relative to participants
            who received sham stimulation. Of primary interest was a within-group analysis of the
            experimental group, showing that the rate of learning was positively correlated with
            rMT: Participants who were more sensitive to brain stimulation as operationalized by our
            TMS proxy (low rMT), showed faster adaptation.
          </p>

          <p>
            <strong>Conclusions:</strong> Methodologically, the results indicate that TMS
            sensitivity can predict tDCS efficacy in a behavioral task, providing insight into one
            source of variability that may contribute to replication problems with tDCS.
            Theoretically, the results provide further evidence of a role of sensorimotor cortex in
            adaptation, with the boost from tDCS observed during acquisition.
          </p>
        </div>

        <div className="research-publication">
          <h3>Publication</h3>
          <p>
            For more details, please refer to our published paper:
            <br />
            <a
              href="https://pubmed.ncbi.nlm.nih.gov/30930208/"
              target="_blank"
              rel="noopener noreferrer"
              className="publication-link"
            >
              Individual differences in TMS sensitivity influence the efficacy of tDCS in
              facilitating sensorimotor adaptation
            </a>
          </p>
        </div>

        <div className="research-publication">
          <h3>Research Poster</h3>
          <p>View or download our research poster:</p>
          <a href="/poster.pdf" download className="publication-link">
            Download Research Poster PDF
          </a>
        </div>
      </div>
    </div>
  );
};

export default ResearchPage;
